﻿"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const net = require("@ivanlog/net");
const gs = require("@ivanlog/gs");
const modal = require("@ivanlog/gs-com-modal_dialogs");
const AstraCabAdminAPI_js_1 = require("../api/admin/AstraCabAdminAPI.js");
const AstraCabDriverAPI_js_1 = require("../api/driver/AstraCabDriverAPI.js");
const AstraCabCustomerAPI_js_1 = require("../api/customer/AstraCabCustomerAPI.js");
class APIsConnector {
    constructor(app) {
        this._app = app;
        this._admin = new AstraCabAdminAPI_js_1.AstraCabAdminAPI(APIsConnector.AdminAPIUrl, (e) => this.apiErrorHandler(e));
        this._driver = new AstraCabDriverAPI_js_1.AstraCabDriverAPI(APIsConnector.DriverAPIUrl, (e) => this.apiErrorHandler(e));
        this._customer = new AstraCabCustomerAPI_js_1.AstraCabCustomerAPI(APIsConnector.CustomerAPIUrl, (e) => this.apiErrorHandler(e));
    }
    get admin() { return this._admin; }
    ;
    get driver() { return this._driver; }
    ;
    get customer() { return this._customer; }
    ;
    setSid(sid) {
        this._admin.getHTTPClient().setHeader("SID", sid);
        this._driver.getHTTPClient().setHeader("SID", sid);
        this._customer.getHTTPClient().setHeader("SID", sid);
        if (!sid)
            gs.helpers.web.setCookie("SID", "", { 'max-age': -1, expires: "" });
    }
    apiErrorHandler(e, showErrors = true) {
        if (e.code) {
            switch (e.code) {
                case net.HTTPCodes.NotFound:
                    new modal.DialogOk("Requested content not found.").show();
                    return;
                case net.HTTPCodes.ServerInternalError:
                    new modal.DialogOk("Catched service error. We are already working on it.").show();
                    return;
                case net.HTTPCodes.ServiceUnavailable:
                    new modal.DialogOk("Service don't work. Try again later.").show();
                    return;
                case net.HTTPCodes.Forbidden:
                    this._app.auth.refreshUser();
                    new modal.DialogOk("You have no access for it.").show();
                    return;
                case net.HTTPCodes.Unauthorized:
                    this._app.auth.logout(false);
                    return;
            }
        }
        const fail = e; // gs.def.toType(e, ResultFail);
        if (fail.actionCode) {
            if (fail.message)
                if (showErrors)
                    new modal.DialogOk(fail.message).show();
                else
                    console.error(fail);
            return;
        }
        const error = gs.def.toType(e, net.NetError);
        if (error) {
            if (!error.skipProccessing)
                if (error.message)
                    if (showErrors)
                        new modal.DialogOk(error.message).show();
                    else
                        console.error(error);
            return;
        }
        throw e;
    }
}
exports.default = APIsConnector;
APIsConnector.AdminAPIUrl = "https://cabtest.ifcase.org";
APIsConnector.DriverAPIUrl = "https://cabtest.ifcase.org";
APIsConnector.CustomerAPIUrl = "https://cabtest.ifcase.org";
//# sourceMappingURL=APIsConnector.js.map